import { FETCH_ORGANIZATIONS } from './types';

const initialState = {
  loading: false,
  data: {},
};

export default class OrgsReducers {
  static allOrgsReducer(state = initialState, action) {
    switch (action.type) {
      case `${FETCH_ORGANIZATIONS}_PENDING`:
        return {
          ...state,
          loading: true,
        };
      case `${FETCH_ORGANIZATIONS}_FULFILLED`:
        return {
          ...state,
          loading: false,
          data: action.payload,
        };
      case `${FETCH_ORGANIZATIONS}_REJECTED`:
        return {
          ...state,
          loading: false,
          data: action.payload,
        };
      default:
        return state;
    }
  }
}
